import {apiWithToken} from '../../../systems/api/index';
import {API_URL} from '../../../systems/globalContant/index';

export default {
    deleteInvoiceCodeFromTransaction: (datas) => apiWithToken.delete(API_URL.DELETE_INVOICE_CODE_2_TRANSACTION.replace("{id_transaction_invoice_code}", datas.id_transaction_invoice_code), {...datas}, {loading: false}),
};